<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10ofa8/tc-custom/9780547542768.jpg?1718169669580" alt="This image is the cover for the book Nature of Monsters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nature of Monsters
      </h1>
      <p class="bookDescription body article font2">
        <b>A pregnant teenager discovers her employer’s sinister secrets in an eighteenth-century London that “feels alive and intense, magnificently raw” (<i>The New York Times Book Review</i>).</b><br/>  <br/> 1666: The Great Fire of London sweeps through the streets and a heavily pregnant woman flees the flames. A few months later she gives birth to a child disfigured by a red birthmark. 1718: Sixteen-year-old Eliza Tally sees the gleaming dome of St. Paul’s Cathedral rising above a rebuilt city. She arrives as an apothecary’s maid, a position hastily arranged to shield the father of her unborn child from scandal. But why is the apothecary so eager to welcome her when he already has a maid, a half-wit named Mary? Why is Eliza never allowed to look her veiled master in the face or go into the study where he pursues his experiments? It is only on her visits to the Huguenot bookseller who supplies her master’s scientific tomes that she realizes the nature of his obsession. And she knows she has to act to save not just the child but Mary and herself. This ebook includes a sample chapter of <i>Beautiful Lies</i>.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Clare Clark
      </h2>
      
      <p class="authorDescription body article">Clare Clark is the author of four novels, including <I>The Great Stink</I>, which was long-listed for the Orange Prize and named a Washington Post Best Book of the Year, and <I>Savage Lands</I>, also long-listed for the Orange Prize. Her work has been translated into five languages. She lives in London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a2a122e